/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BucketObject } from './bucketObject';


export interface LambdaBucketInfo { 
    /**
     * bucket object
     */
    bucket_object?: Array<BucketObject>;
}

